/**
 * created by wang lei
  部门筛选 页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../../base/BaseComponent";
import {TreeSelect} from "antd";
import {getInfoFromLocalStorage} from "../../../../../../../actions";
const { TreeNode } = TreeSelect;

export default class Sta_selectTreeDeptById extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            format:{
                title: "name",
                key: "id",
                value:"id",
                children: "child",
            },
            //搜索文字
            viewSearchValue:""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // this.getDeptIds()
        this.getTree()
    }

    handleSearch = (val) =>{
        this.setState({
            viewSearchValue:val
        })
    }

    handleBlur = () =>{
        setTimeout(() => {
            this.setState({
                viewSearchValue:""
            })
        }, 100);
    }

    getDeptIds = () => {
        let {config,onChange,labelCode} =this.props
        if(config?.defaultValue){
            let deptIds = getInfoFromLocalStorage("currentUser").defaultInfo.dept.id
            onChange({labelCode,val:deptIds.toString()},()=>{
                onChange({fun: "onSearch"})
            })
        }
    }

    render() {
        const {
            value,
            onChange,
            config={},
            labelCode,
            size,
            disabled,
            id,
            placeholder,
        } = this.props;
        const {style={},searchPlaceholder,maxTagCount} = config;
        let {treeData,viewSearchValue} =this.state
        return (
            <div className={'treeSelect_dept_by_id'}>
                <TreeSelect
                    showSearch
                    style={{...style}}
                    value={value && value.length ? value.split(",") :null}
                    dropdownStyle={{maxHeight: 400, overflow: 'auto',maxWidth:style.width}}
                    dropdownClassName={'tree-select-custom-class-name'}
                    placeholder={placeholder}
                    // searchPlaceholder={searchPlaceholder}
                    allowClear={false}
                    multiple
                    treeDefaultExpandAll
                    onChange={(v) => {
                        console.log(v)
                        // this.setState({value:v})
                        onChange({labelCode, val: v.toString()})
                    }}
                    onSearch={this.handleSearch}
                    searchValue={viewSearchValue}
                    onBlur={this.handleBlur}
                    size={size}
                    disabled={disabled}
                    treeData={treeData}
                    id={id}
                    filterTreeNode={(input, treeNode) => {
                        console.log(input, treeNode)
                        return treeNode.props.title.includes(input)
                    }}
                    maxTagCount={maxTagCount}
                >
                </TreeSelect>
                <style>
                    {
                        `.treeSelect_dept_by_id .ant-select-selection--multiple .ant-select-selection__choice {max-width:110px}
                         .tree-select-custom-class-name .ant-select-tree li .ant-select-tree-node-content-wrapper { width:auto !important}
                        `
                    }
                </style>
            </div>

        )
    }

    format = (tree) => {
        let {formatConfig} = this.props.config
        if (tree?.length && formatConfig ) {
            tree.forEach(item => {
                for (let i in formatConfig) {
                    item[i] = item[formatConfig[i]]
                }
                if (item?.children?.length) {
                    this.format(item?.children)
                }
            })
        }
    }
    checkData = (tree,call) => {
        let {deleteRootNode, treeId} = this.props.config
        let newTreeData = [];
        if (tree?.length) {
            newTreeData = tree;
            if(deleteRootNode && treeId) {
                tree.forEach(item => {
                    if (item.id == treeId) {
                        newTreeData = item.children
                    }
                })
            }
        }
        return newTreeData
    }

    getTree = () => {
        let {config} =this.props
        this.request({
            url: '/cm-sites-sys/dept/getTree',
            body:config?.treeId,
            method:'post',
            callBack:(res)=>{
                let tree = [];
                if(res.id) {
                    tree = [res]
                }
                this.format(tree)
                let newTree = this.checkData(tree)
                this.setState({treeData:newTree})
            }
        })
    }
}